import axios from '../utils/axios';

export function getUnmappedRecruitersCount(adminId, params) {
    return axios.get(`/admin/${adminId}/get-active-unverified-recruiters-count`, { params });
}
